import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'user-active-transfer-act',
  templateUrl: './user-active-transfer-act.component.html',
  styleUrls: ['./user-active-transfer-act.component.scss']
})
export class UserActiveTransferActComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
